import { mystic } from '../../constants/Colors';

export const fadeInDelay = (delay, duration = 334, pixels = -10) => ({
    opacity: '0',
    transform: `translateY(${pixels}px)`,
    animation: `fade-slide-in ${duration}ms cubic-bezier(0, 0, .2, 1) forwards`,
    animationDelay: `${delay}ms`,
});

export const fadeOutDelay = (delay, duration = 334) => ({
    opacity: '0',
    transform: 'translateY(10px)',
    animation: `fade-slide-out ${duration}ms cubic-bezier(0, 0, .2, 1) forwards`,
    animationDelay: `${delay}ms`,
});

export const pulse = (background = mystic) => ({
    background,
    animation: 'pulse .65s infinite alternate',
    borderRadius: '3px',
    boxSizing: 'border-box',
});
